export default __webpack_public_path__ + "static/media/num-icon3.a3d5adea.svg";